import { leerDeLaPestana } from '@nebula-shared/data-access';

export function generarIdentificadorDescarga(
  funcionalidad: string,
  fecha: Date = new Date(),
): string {
  const empresa = leerDeLaPestana('companyName') ?? '';

  const year = fecha.getFullYear().toString();

  const month = String(fecha.getMonth() + 1).padStart(2, '0');

  const day = String(fecha.getDate()).padStart(2, '0');

  const hours = String(fecha.getHours()).padStart(2, '0');

  const minutes = String(fecha.getMinutes()).padStart(2, '0');

  const seconds = String(fecha.getSeconds()).padStart(2, '0');
  const milliseconds = String(fecha.getMilliseconds()).padStart(3, '0');

  const segundosCompletos = `${seconds}${milliseconds.charAt(0)}`; // 234

  const fechaFormateada = `${year}${month}${day}${hours}${minutes}${segundosCompletos}`;

  return `${empresa}-${funcionalidad}-${fechaFormateada}`;
}

export function generarNombreArchivo(
  funcionalidad: string,
  extension: string,
  fecha: Date = new Date(),
): string {
  const identificador = generarIdentificadorDescarga(funcionalidad, fecha);
  return `${identificador}.${extension}`;
}
